import '@ant-design/v5-patch-for-react-19';
import { useState, useEffect } from "react";
import { Button, Card, Col, DatePicker, Form, Input, Modal, Row, Select, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";

import api from "../../../services/api";

import "../../../styles/sider.css";

import { errorMessage, successMessage } from '../../../messages/messages';
// import { errorMessage, successMessage } from "../../../messages/messages";

import { ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { carregaCEP, carregaListaMunicipios, carregaListaNaturezasJuridicasIbge, carregaListaPaises, carregaListaUF, consultaCNPJReceita, existeNumeroCadastrado } from "../services";
import { maskCep, maskCnpj, maskNumeroProcesso, maskTelefone, numberOnly } from "../../../utils/maskFunctions";
import { color, isValidNup, onlyNumbers, pushToBase, resetColor } from "../../../utils/utilsFunctions";
import type { IPessoaJuridica, ISelectList } from "../../../components/Interfaces";
import CadInfoBotoes from '../../../components/CadInfoBotoes';
import { hasAnyPermissao } from '../../../components/auth/entidadeUsuario';

const Cadastrar = () => {
  const navigate = useNavigate();
  const { confirm } = Modal;

  const { TextArea } = Input;
  const history = useNavigate();
  // const { confirm } = Modal;
  // Lista que armazena as Naturezas Juridicas retornadas da API
  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [form] = Form.useForm();
  const [tipoIdentificador, setTipoIdentificador] = useState<number>(0); // 0: Não definico / 1: CNPJ / 2: NIF / 3: NÚMERO DE PROCESSO
  const [cnpjAProcessar, setCnpjAProcessar] = useState("");
  const [listaNaturezasJuridicas, setListaNaturezasJuridicas] = useState<ISelectList[]>([]);
  const [listaPaises, setListaPaises] = useState<ISelectList[]>([]);
  const [listaUf, setListaUf] = useState<ISelectList[]>([]);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [codPais, setCodPais] = useState(76); // BRASIL
  const [cepLocalizado, setCepLocalizado] = useState(false);

  const [codNaturezaJuridica, setCodNaturezaJuridica] = useState(0);
  const [modalJaExisteAberto, setModalJaExisteAberto] = useState(false);
  const [modalSucessoAberto, setModalSucessoAberto] = useState(false);

  const [dadosPessoaJuridica, setDadosPessoaJuridica] = useState<IPessoaJuridica>();
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cnaePrincipal, setCnaePrincipal] = useState("");
  const [tipoLogradouro, setTipoLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [pessoaJuridicaJaCadastrada, setPessoaJuridicaJaCadastrada] = useState(false);

  useEffect(() => {
    if (dadosPessoaJuridica) pushToManter(dadosPessoaJuridica, 2);
  }, [dadosPessoaJuridica]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (cnpjAProcessar !== "") {
      handleIdentificador(1, cnpjAProcessar);
    } else {
      handleIdentificador(0, "");
    }
  }, [cnpjAProcessar]); // eslint-disable-line react-hooks/exhaustive-deps

  function pushToManter(pj: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: pj
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (!hasAnyPermissao()) {
      pushToBase(navigate);
    } else {
      setLoading(true);
      const carregaDadosIniciais = async () => {
        carregaListaPaisesOpcoes();
        carregaListaNaturezasJuridicasOpcoes();
        carregaListaUFOpcoes();
      }
      carregaDadosIniciais();
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (tipoIdentificador !== 1) {
      setCodNaturezaJuridica(0);
      setCnpjAProcessar("");
      setRazaoSocial("");
      setCnaePrincipal("");

      form.setFieldsValue({
        atividadeEconomica: undefined,
        razaoSocial: undefined,
        nomeFantasia: undefined,
        nmNaturezaJuridica: undefined,
        dataAbertura: undefined,
        situacaoCadastral: undefined,
        dataSituacaoCadastral: undefined,
        cep: undefined,
        logradouro: undefined,
        numeroEndereco: undefined,
        nmPais: undefined,
        siglaUf: undefined,
        nomeCidade: undefined,
        bairro: undefined,
        complemento: undefined,
        telefone1: undefined,
        telefone2: undefined,
        email: undefined,
        emailInstitucional: undefined,
        site: undefined
      })
    }

    if (tipoIdentificador === 2) { // NIF
      setCodPais(0);
    }
    if (tipoIdentificador === 3) { // PROCESSO
      setCodPais(76);
    }
  }, [tipoIdentificador]); // eslint-disable-line react-hooks/exhaustive-deps  


  const handleIdentificador = (tpId: number, numeroInformado: string) => {
    if (numeroInformado && numeroInformado !== "") {
      setNumero(onlyNumbers(numeroInformado));
      setTipoIdentificador(tpId);
      if (tpId === 1) { // numero = CNPJ
        existePessoaJuridicaNoCadastro(tpId, numeroInformado);
        form.setFieldsValue({
          cnpjNumero: maskCnpj(numeroInformado),
          numeroIdentificacaoFiscal: undefined,
        })
      } else if (tpId === 2) { // numero = NIF
        existePessoaJuridicaNoCadastro(tpId, numeroInformado);
        form.setFieldsValue({
          cnpjNumero: undefined,
          numeroIdentificacaoFiscal: numeroInformado,
        })
      };
    } else {
      setTipoIdentificador(0);
      setNumero("");
      form.setFieldsValue({
        cnpjNumero: undefined,
        numeroIdentificacaoFiscal: undefined,
      })
    }
  };

  const handleProcessoBlur = (processo: string) => {
    const currentForm = form.getFieldsValue();

    if (processo !== "" && (!currentForm.cnpjNumero || currentForm.cnpjNumero === "")
      && (!currentForm.numeroIdentificacaoFiscal || currentForm.numeroIdentificacaoFiscal === "")) {
      setTipoIdentificador(3);
      setNumero(onlyNumbers(processo));
      existePessoaJuridicaNoCadastro(3, processo);
    }

    form.setFieldsValue({
      numeroProcesso: maskNumeroProcesso(onlyNumbers(processo))
    })
  }


  const handleOkJaExiste = () => {
    setModalJaExisteAberto(false);
    history('/pessoa-juridica/consultar')
  };

  const handleCancelJaExiste = () => {
    setModalJaExisteAberto(false);
    history(-1);
  };
  const handleOkSucesso = () => {
    setModalJaExisteAberto(false);
    history('/pessoa-juridica/consultar')
  };

  const handleCancelSucesso = () => {
    setModalJaExisteAberto(false);
    history('/pessoa-juridica/consultar')
  };


  const validarNumero = () => {
    const { cnpjNumero, numeroIdentificacaoFiscal, numeroProcesso } = form.getFieldsValue();

    if (cnpjNumero && numeroIdentificacaoFiscal) {
      errorMessage("CNPJ e Número de Identificação Fiscal não podem ser ambos preenchidos.");
      return;
    }

    if (numeroProcesso && !isValidNup(numeroProcesso)) {
      errorMessage("Número de Processo inválido");
      return;
    }

    if (!cnpjNumero && !numeroIdentificacaoFiscal && !numeroProcesso) {
      errorMessage("CNPJ, Número de Identificação Fiscal e Processo não podem ser todos vazios.");
      return;
    }

    if ((!cnpjNumero && !numeroIdentificacaoFiscal) && numeroProcesso) {
      mostrarConfirmarCadastroPorNumeroProcesso();
    } else {
      validarPessoaJuridica();
    }

  }

  const validarPessoaJuridica = () => {
    if (pessoaJuridicaJaCadastrada) {
      return
    }
    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    setLoading(true);
    const currentForm = form.getFieldsValue();
    //console.log(currentForm)

    const json: IPessoaJuridica = {
      numero: numero,
      serie: undefined,
      nomeFantasia: currentForm?.nomeFantasia,
      razaoSocial: currentForm?.razaoSocial,
      numeroCnae: cnaePrincipal !== "" ? cnaePrincipal : undefined,
      //validada: data.validada,
      observacao: currentForm?.observacao,
      naturezaJuridica: codNaturezaJuridica,
      numeroProcesso: numberOnly(
        currentForm?.numeroProcesso === "" ? "" : currentForm?.numeroProcesso
      ),
      cep: numberOnly(currentForm?.cep),
      tipoLogradouro: tipoLogradouro !== "" ? tipoLogradouro.toUpperCase() : undefined,
      logradouro: currentForm.logradouro.toUpperCase(),
      numeroEndereco: currentForm.numeroEndereco.toUpperCase(),
      complemento: currentForm?.complemento ? currentForm?.complemento.toUpperCase() : undefined,
      bairro: currentForm?.bairro ? currentForm?.bairro.toUpperCase() : undefined,
      siglaUf: currentForm?.siglaUf.toUpperCase(),
      telefone1: numberOnly(currentForm?.telefone1),
      telefone2: currentForm?.telefone2 ? numberOnly(currentForm?.telefone2) : undefined,
      nomePais: currentForm?.nmPais.toUpperCase(),
      pais: codPais,
      site: currentForm?.site ? currentForm?.site.toLowerCase() : undefined,
      email: currentForm?.email,
      emailInstitucional: currentForm?.emailInstitucional,
      nomeCidade: currentForm?.nomeCidade.toUpperCase(),
      tipoIdentificador: tipoIdentificador,
    };

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = "";
      if (tipoIdentificador === 1) {
        query = `/versionar/${numero}/numero`;
      } else {
        query = `/versionar/${tipoIdentificador}/${numero}/numero`
      }
      const { data } = await api.post(query, json);
      setLoading(false);
      setDadosPessoaJuridica(data);

      successMessage(
        `Pessoa Jurídica "${currentForm?.razaoSocial}" cadastrada com Sucesso`
      );


    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const resetForm = () => {
    setLoading(true);
    form.resetFields();
    setTipoIdentificador(0);
    setCnpjAProcessar("");
    setCodNaturezaJuridica(0);
    setCodPais(76); // VOLTA AO PADRÃO (BRASIL)
    setDadosPessoaJuridica(undefined);
    setLoading(false);
  };

  const carregaListaNaturezasJuridicasOpcoes = async () => {
    let listaLocal: any = [];
    //    await carregaListaNaturezasJuridicas().then((response) => {
    await carregaListaNaturezasJuridicasIbge().then((response) => {
      response.data.forEach((p: any) => {
        // listaLocal.push({ value: p.codigo, label: p.descricao });
        listaLocal.push({ value: p.codNaturezaJuridica, label: (p.codNaturezaJuridica + " - " + p.descNaturezaJuridica.toUpperCase()) });
      })
    });

    setListaNaturezasJuridicas(listaLocal);
  }

  const carregaListaPaisesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaPaises().then((response) => {
      response.data.forEach((p: any) => {
        // if (p.id['M49'] !== 76) {  // BRASIL
        //   listaLocal.push({ value: p.id['M49'], label: p.nome });
        // }
        listaLocal.push({ value: p.id['M49'], label: p.nome });
      });
    });

    const sortedList = [...listaLocal].sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    // Coloca o Brasil no tipo da lista
    const brasilItem = sortedList.find(x => x.value === 76);
    const newList = [brasilItem, ...sortedList.filter(x => x.value !== 76)];
    setListaPaises(newList);
  }

  const carregaListaUFOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUF().then((response) => {
      response.data.forEach((p: any) => {
        listaLocal.push({ value: p.id, label: p.sigla })
      });
    });
    setListaUf(listaLocal);
  }

  function mostrarConfirmarCadastroPorNumeroProcesso() {
    confirm({
      title: "Deseja confirmar o cadastro da Pessoa Jurídica somente com o Número de Processo?",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: `Número do Processo: ${maskNumeroProcesso(numero)}`,
      okButtonProps: { id: 'ok' },
      onOk() { validarPessoaJuridica(); },
      onCancel() { },
    });

  }

  const existePessoaJuridicaNoCadastro = async (tipoId: number, value: string) => {
    setLoading(true);
    setTipLoading("Verificando existência de CNPJ");

    let numberOnlyValue = numberOnly(value);
    let existe = false;

    await existeNumeroCadastrado(tipoId, numberOnlyValue).then((response) => {
      if (response.status === 200) {
        existe = true;
      }
    }).catch(_err => {
      errorMessage("Erro ao validar se Pessoa jurídica já é cadastrada.");
      setLoading(false);
    });

    setPessoaJuridicaJaCadastrada(existe);

    if (existe) {
      errorMessage("Pessoa jurídica já cadastrada.");
    } else if (tipoId === 1) { // CNPJ
      carregaCnpjEPreencheDados(value);
    }
    setLoading(false);
  }

  const carregaCnpjEPreencheDados = async (value: string) => {
    if (value !== "") {

      return consultaCNPJReceita(numberOnly(value)).then(async (resposta) => {

        setCodNaturezaJuridica(resposta.data.naturezaJuridica?.codigo);
        setRazaoSocial(resposta.data.nomeEmpresarial);
        setCnaePrincipal(resposta.data.cnaePrincipal?.codigo);
        setTipoLogradouro(resposta.data.endereco.tipoLogradouro);

        form.setFieldsValue({
          cnpjNumero: maskCnpj(resposta.data.ni),
          atividadeEconomica: resposta.data.cnaePrincipal?.codigo + " - " + resposta.data.cnaePrincipal?.descricao.toUpperCase(),
          nmNaturezaJuridica: listaNaturezasJuridicas.find(x => x.value === resposta.data.naturezaJuridica?.codigo),
          nomeFantasia: resposta.data.nomeFantasia,
          razaoSocial: resposta.data.nomeEmpresarial,
          dataAbertura: resposta.data.dataAbertura ? dayjs(resposta.data.dataAbertura) : undefined,
          situacaoCadastral: resposta.data.situacaoCadastral?.codigo,
          dataSituacaoCadastral: resposta.data.situacaoCadastral?.data ? dayjs(resposta.data.situacaoCadastral?.data) : undefined,
          nmPais: resposta.data.endereco.pais.descricao,
          cep: maskCep(resposta.data.endereco.cep),
          numeroEndereco: resposta.data.endereco.numero,
          telefone1: resposta.data.telefones && resposta.data.telefones[0]?.ddd ? maskTelefone(resposta.data.telefones[0].ddd + resposta.data.telefones[0].numero) : undefined,
          telefone2: resposta.data.telefones && resposta.data.telefones[1]?.ddd ? maskTelefone(resposta.data.telefones[1].ddd + resposta.data.telefones[1].numero) : undefined,
        });
        await carregaCepEPreencheEndereco(resposta.data.endereco.cep);
      });
    }
  };

  const carregaCepEPreencheEndereco = async (cep: string) => {
    setTipLoading("Buscando CEP");
    setLoading(true);
    return carregaCEP(cep).then((responseCep) => {
      setCepLocalizado(true);
      let estado = listaUf.find(u => u.label === responseCep.data.uf);
      carregaListaMunicipios(estado?.value).then((responseMun) => {
        let l = responseMun.data.map((m: { id: any; nome: any; }) => {
          return { value: m.id, label: m.nome }
        });
        setListaMunicipios(l);
        let munic = l.find((m: { label: string; }) => m.label.toUpperCase() === responseCep.data.cidade.toUpperCase());
        form.setFieldsValue({
          // nomeCidade: munic.value,
          nomeCidade: munic.label.toUpperCase(),
        });
      });
      form.setFieldsValue({
        // siglaUf: listaUf.find(u => u.label === responseCep.data.uf)?.value,
        nmPais: "BRASIL",
        codPais: "76",
        siglaUf: responseCep.data.uf,
        bairro: responseCep.data.bairro.toUpperCase(),
        logradouro: responseCep.data.endereco.toUpperCase(),
        complemento: responseCep.data.complemento.toUpperCase(),
      });
      setTipLoading("");
      setLoading(false);
    })
      .catch(err => {
        setCepLocalizado(false);
        let data: any = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        errorMessage(msgErro);
        setLoading(false);
      });
  };

  const handleNaturezaJuridica = async (naturezaJuridica: any) => {

    form.setFieldsValue({
      nmNaturezaJuridica: naturezaJuridica.label,
    });

    setCodNaturezaJuridica(naturezaJuridica.value);
  };

  const handlePais = async (pais: any) => {
    form.setFieldsValue({
      nmPais: pais.label,
    });

    setCodPais(pais.value);

    if (pais.value !== 76) { // BRASIL
      form.setFieldsValue({
        siglaUf: undefined,
        nomeCidade: undefined,
      });
    }
  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  // if (loading) {
  //   return <Spin />;
  // }

  return (
    <Spin spinning={loading} tip={tipLoading}>

      <Modal title="Já existe" open={modalJaExisteAberto} onOk={handleOkJaExiste}
        onCancel={handleCancelJaExiste}>
        <p>A Pessoa jurídica já está cadastrada no sistema.</p>
      </Modal>
      <Modal title="Sucesso" open={modalSucessoAberto} onOk={handleOkSucesso}
        onCancel={handleCancelSucesso} cancelButtonProps={{ disabled: true }}>
        <p>A Pessoa jurídica foi cadastrada com sucesso.</p>
      </Modal>

      <Form layout='vertical' style={{ padding: 24 }} onFinish={validarNumero} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >


        <div className="main-content pl-sm-3 mt-4">
          <h1>Cadastrar Pessoa Jurídica</h1>
        </div>

        <Card>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas</h2>
          </div>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'>
                <Input maxLength={18}
                  disabled={tipoIdentificador === 2}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cnpjNumero: maskCnpj(e.target.value),
                    })
                  }
                  onBlur={(e) =>
                    setCnpjAProcessar(e.target.value)
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={2}>
              <Tooltip title='Buscar CNPJ'>
                <Button
                  shape='round' type='primary' icon={<SearchOutlined />}
                  disabled={tipoIdentificador === 2}
                  style={{ marginTop: "30px", marginLeft: "3px" }}
                  onClick={() => {
                    if (cnpjAProcessar !== form.getFieldValue('cnpjNumero')) {
                      setCnpjAProcessar(form.getFieldValue('cnpjNumero'));
                    }
                  }} >
                  {/* Buscar CNPJ */}
                </Button>
              </Tooltip>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Número de Identificação Fiscal (NIF)'
                name='numeroIdentificacaoFiscal'
              >
                <Input
                  maxLength={21}
                  disabled={tipoIdentificador === 1}
                  onBlur={(e) =>
                    handleIdentificador(2, e.target.value)
                  }
                />

              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Número do Processo'
                name='numeroProcesso'
                rules={[
                  {
                    required: tipoIdentificador > 1,
                    message: "Número do processo não preenchido",
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  onChange={(e) =>
                    form.setFieldsValue({
                      numeroProcesso: maskNumeroProcesso(e.target.value),
                    })
                  }
                  onBlur={(e) =>
                    handleProcessoBlur(e.target.value)
                  }
                />

              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={15}>
              <Form.Item
                label='Nome Empresarial'
                name='razaoSocial'
                rules={[
                  {
                    required: true,
                    message: "Razão Social é Obrigatório",
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  onChange={(e) =>
                    setRazaoSocial(e.target.value)
                  }
                  disabled={tipoIdentificador === 1}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Nome Fantasia'
                name='nomeFantasia'
                rules={[
                  {
                    required: true,
                    message: "Nome Fantasia não preenchido",
                  },
                ]}
              >
                <Input maxLength={100}
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                  onChange={(e) =>
                    form.setFieldsValue({
                      nomeFantasia: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4" style={{ display: tipoIdentificador === 1 ? "inline" : "none" }}>
            <h2>Informações da Receita Federal</h2>
          </div>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Natureza Jurídica'
                name='nmNaturezaJuridica'
                rules={[
                  {
                    required: true,
                    message: "Natureza Jurídica é Obrigatório"
                  },]} >
                <Select
                  disabled={tipoIdentificador === 1}
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA NATUREZA JURÍDICA'
                  options={listaNaturezasJuridicas}
                  onChange={(_, index) => {
                    handleNaturezaJuridica(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={12} hidden={tipoIdentificador !== 1}>
              <Form.Item
                label='Atividade Econômica Principal'
                name='atividadeEconomica'>
                <Input maxLength={100}
                  disabled={true}
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row hidden={tipoIdentificador !== 1}>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Data de Abertura'
                name='dataAbertura' >
                <DatePicker
                  // disabled={tipoIdentificador === 1}
                  disabled={true}
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Selecionar Data"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Situação Cadastral'
                name='situacaoCadastral'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Data Situação Cadastral'
                name='dataSituacaoCadastral' >
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Motivo da Situação Cadastral'
                name='motivoSituacao'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Endereço</h2>
          </div>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label={codPais === 76 ? 'CEP' : 'Código Postal'}
                name='cep'
                rules={[{
                  required: true,
                  message: "Código Postal obrigatório não preenchido",
                },]}>
                {codPais === 76 ? (
                  <Input maxLength={10}
                    onChange={(e) =>
                      form.setFieldsValue({
                        cep: maskCep(e.target.value),
                      })
                    }
                    style={{ width: "100%", backgroundColor: color.cepColor }}
                    disabled={tipoIdentificador === 1 && cepLocalizado} />
                ) : (
                  <Input maxLength={20} disabled={false} />
                )}

              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={2}>
              <Tooltip title='Buscar CEP'>
                <Button
                  shape='round' type='primary' icon={<SearchOutlined />}
                  disabled={tipoIdentificador <= 2 && cepLocalizado}
                  style={{ marginTop: "30px", marginLeft: "3px" }}
                  onClick={() => {
                    carregaCepEPreencheEndereco(form.getFieldValue('cep'))
                  }} >
                  {/* Buscar CEP */}
                </Button>
              </Tooltip>
            </Col>

            <Col xs={24} xl={11}>
              <Form.Item
                label='Logradouro'
                name='logradouro'
                rules={[{
                  required: true,
                  message: "Endereco obrigatório não preenchido",
                },]}
              >
                <Input maxLength={100}
                  disabled={tipoIdentificador === 1}
                  style={{ backgroundColor: color.enderecoColor }} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label='Número'
                name='numeroEndereco'
                rules={[{
                  required: tipoIdentificador !== 1,
                  message: "Número obrigatório não preenchido",
                },]}>
                <Input maxLength={10}
                  disabled={tipoIdentificador === 1}
                  style={{ backgroundColor: color.numeroColor }} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label='País'
                name='nmPais'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}
              >
                <Select showSearch filterOption optionFilterProp='children'
                  placeholder='País'
                  disabled={tipoIdentificador !== 2}
                  options={listaPaises}
                  onChange={(_, index) => {
                    handlePais(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4}>
              <Form.Item
                label='UF'
                name='siglaUf'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Estados'
                    className={color.ufColor === "#ffdada" ? "input" : ""}
                    disabled={true}
                    onChange={(e) => {
                      carregaListaMunicipios(e.value).then((response) => {
                        setListaMunicipios(response.data);
                      });
                    }
                    }
                    options={listaUf} />
                ) : (
                  <Input maxLength={100} disabled={false} />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Município'
                name='nomeCidade'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Município'
                    className={
                      color.municipioColor === "#ffdada" ? "input" : ""
                    }
                    disabled={true}
                    options={listaMunicipios} />
                ) : (
                  <Input maxLength={100} disabled={false} />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Bairro'
                name='bairro'
              // rules={[{
              //   required: true,
              //   message: "Campo obrigatório não preenchido",
              // },]}
              >
                <Input maxLength={60}
                  disabled={tipoIdentificador === 1}
                  style={{ backgroundColor: color.bairroColor }} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Complemento'
                name='complemento'>
                <Input maxLength={30}
                  disabled={tipoIdentificador === 1}
                  style={{ backgroundColor: color.complementoColor }} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 1'
                name='telefone1'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                <Input maxLength={15}
                  onChange={(e) =>
                    form.setFieldsValue({
                      telefone1: maskTelefone(e.target.value),
                    })
                  }
                  style={{
                    width: "100%",
                    backgroundColor: color.telefone1Color,
                  }}
                  disabled={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 2'
                name='telefone2'>
                <Input maxLength={15}
                  onChange={(e) =>
                    form.setFieldsValue({
                      telefone2: maskTelefone(e.target.value),
                    })
                  }
                  style={{ width: "100%" }}
                  disabled={false}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail'
                name='email'
                rules={[
                  {
                    required: true,
                    message: "Digite um email válido",
                    type: "email",
                  },
                ]} >
                <Input maxLength={100} disabled={false}
                  style={{
                    textTransform: "lowercase",
                    backgroundColor: color.emailColor,
                  }} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail Comunicação PREVIC'
                name='emailInstitucional'
                rules={[
                  {
                    message: "Digite um email válido",
                    type: "email",
                  },
                ]} >
                <Input maxLength={100} disabled={false}
                  style={{ textTransform: "lowercase" }} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Site'
                name='site'>
                <Input className='lowercase' maxLength={100} disabled={false}
                  addonBefore={(
                    <Select defaultValue='https://' className='select-before lowercase' options={[
                      { value: 'http://', label: 'http://' },
                      { value: 'https://', label: 'https://' }
                    ]}>
                    </Select>
                  )} />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Complementares</h2>
          </div>

          <Row>
            <Col span={24}>
              <Form.Item
                label='Observações'
                name='observacao'>
                <TextArea disabled={false} placeholder='' maxLength={300} showCount={true}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  onChange={(e) =>
                    form.setFieldsValue({
                      observacao: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <CadInfoBotoes
          resetForm={resetForm}
          detalhar={false}
          form={form}
          resetColor={resetColor}
          manter={1}
          msgConfirmacao={razaoSocial}
          rotaConsultar={"/" + import.meta.env.VITE_APP_BASE}
        />

      </Form>

    </Spin>
  );
};

export default Cadastrar;

